export class HttpClientError extends Error {
	public readonly method: string;
	public readonly path: string;
	public readonly status: number;
	public readonly body: string;

	constructor(method: string, path: string, status: number, body: string) {
		super(`HTTP ${method} ${path} failed with status ${String(status)}`);

		this.name = 'HttpClientError';
		this.method = method;
		this.path = path;
		this.status = status;
		this.body = body;
	}
}
